var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{staticClass:"text-center"},[_c('i',{staticClass:"fas fa-3x fa-lock"}),_c('h1',[_vm._v("Restricted")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }